import { render, staticRenderFns } from "./Amount.vue?vue&type=template&id=f036569a&scoped=true&"
import script from "./Amount.vue?vue&type=script&lang=js&"
export * from "./Amount.vue?vue&type=script&lang=js&"
import style0 from "./Amount.vue?vue&type=style&index=0&id=f036569a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f036569a",
  null
  
)

export default component.exports